import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Apttus3Service {

  constructor() { }
}
